import React from 'react';
import PropTypes from 'prop-types';
import { List, Item, ItemSelectable, ItemHeader } from './StyledComponents';

const getVisibleOptions = (options, hasFilter, isSameTermAsPristineValue) =>
  options.filter((option) => {
    const hasFilterAndResults = option.isFiltered && hasFilter;
    return !hasFilter || isSameTermAsPristineValue || hasFilterAndResults;
  });

const Results = ({
  options, hasFilter, isSameTermAsPristineValue, onChange, setState,
}) => {
  const visibleOptions = getVisibleOptions(options, hasFilter, isSameTermAsPristineValue);

  return (
    <List>
      {visibleOptions.length > 0 &&
        visibleOptions.map(option => (
          <Item key={option.value}>
            {option.isHeader ? (
              <ItemHeader>{option.label}</ItemHeader>
            ) : (
              <ItemSelectable
                onClick={() => {
                  setState(option);
                  onChange(option);
                }}
              >
                {option.label}
              </ItemSelectable>
            )}
          </Item>
        ))}
      {visibleOptions.length === 0 && <Item>No Results</Item>}
    </List>
  );
};

Results.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    highlight: PropTypes.bool,
    label: PropTypes.string,
  })).isRequired,
  hasFilter: PropTypes.bool.isRequired,
  isSameTermAsPristineValue: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
};

export default Results;
